/* ==========================================================================
   bororo — コレクションページ 絞り込み／表示順
   ルクルーゼ式の折り畳み挙動と、表示順・価格帯の操作をテーマ標準の
   フィルター処理（component-filtering.js）に受け渡します。
   ========================================================================== */

(function () {
  'use strict';

  if (window.__bororoCollection) return;
  window.__bororoCollection = true;

  /* ---- テーマJSの inert 解除 ---------------------------------------- */
  /* component-filtering.js は「画面幅991px以下＝ドロワー」という前提で
     #CollectionFiltersForm に inert を付けます。bororoデザインはドロワーを
     使わずその場で開くため、inert が付いたままだと折り畳みバーが
     クリックできなくなります。付与されたら都度外します。 */

  function releaseInert() {
    var form = document.getElementById('CollectionFiltersForm');
    if (form && form.hasAttribute('inert')) form.removeAttribute('inert');
  }

  function watchInert() {
    var form = document.getElementById('CollectionFiltersForm');
    if (!form) return;
    releaseInert();
    new MutationObserver(releaseInert).observe(form, {
      attributes: true,
      attributeFilter: ['inert']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchInert);
  } else {
    watchInert();
  }
  window.addEventListener('resize', releaseInert);
  window.addEventListener('load', releaseInert);

  /* ---- 折り畳み（片方を開くともう片方を閉じる） ---------------------- */

  function panelFor(root, name) {
    return root.querySelector('[data-bo-fold-panel="' + name + '"]');
  }

  function closeFold(root, name) {
    var head = root.querySelector('[data-bo-fold-head="' + name + '"]');
    var panel = panelFor(root, name);
    if (head) head.setAttribute('aria-expanded', 'false');
    if (panel) panel.classList.remove('is-open');
  }

  function toggleFold(root, name) {
    var head = root.querySelector('[data-bo-fold-head="' + name + '"]');
    var panel = panelFor(root, name);
    if (!head || !panel) return;

    var isOpen = head.getAttribute('aria-expanded') === 'true';

    root.querySelectorAll('[data-bo-fold-head]').forEach(function (other) {
      closeFold(root, other.getAttribute('data-bo-fold-head'));
    });

    if (!isOpen) {
      head.setAttribute('aria-expanded', 'true');
      panel.classList.add('is-open');
    }
  }

  /* ---- 表示順：テーマ標準のセレクトに橋渡し -------------------------- */

  function applySort(root, value, button) {
    var select = document.getElementById('SortBydesktop');
    if (!select) return;

    root.querySelectorAll('[data-bo-sort]').forEach(function (b) {
      b.classList.remove('is-active');
    });
    if (button) button.classList.add('is-active');

    select.value = value;
    select.dispatchEvent(new Event('change', { bubbles: true }));

    // ルクルーゼ同様、選択したらパネルを閉じる
    closeFold(root, 'sort');
  }

  /* ---- 価格帯プリセット ---------------------------------------------- */

  function applyPriceBand(root, button) {
    var form = document.getElementById('CollectionFiltersForm');
    if (!form) return;

    var minInput = form.querySelector('input[data-price-range-min]');
    var maxInput = form.querySelector('input[data-price-range-max]');
    if (!minInput || !maxInput) return;

    var wasActive = button.classList.contains('is-active');

    root.querySelectorAll('[data-bo-price-band]').forEach(function (b) {
      b.classList.remove('is-active');
    });

    if (wasActive) {
      minInput.value = '';
      maxInput.value = '';
    } else {
      button.classList.add('is-active');
      minInput.value = button.getAttribute('data-min') || '';
      maxInput.value = button.getAttribute('data-max') || '';
    }

    minInput.dispatchEvent(new Event('input', { bubbles: true }));
    maxInput.dispatchEvent(new Event('input', { bubbles: true }));
  }

  /* ---- イベント委譲（Ajax差し替え後も効くように） -------------------- */

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var head = target.closest('[data-bo-fold-head]');
    if (head) {
      event.preventDefault();
      toggleFold(head.closest('[data-bo-fold-root]'), head.getAttribute('data-bo-fold-head'));
      return;
    }

    var sortBtn = target.closest('[data-bo-sort]');
    if (sortBtn) {
      event.preventDefault();
      applySort(sortBtn.closest('[data-bo-fold-root]'), sortBtn.getAttribute('data-bo-sort'), sortBtn);
      return;
    }

    var band = target.closest('[data-bo-price-band]');
    if (band) {
      event.preventDefault();
      applyPriceBand(band.closest('[data-bo-fold-root]'), band);
      return;
    }

    var more = target.closest('[data-bororo-stone-more]');
    if (more) {
      var bar = more.closest('.bororo-stone-tags');
      if (bar) bar.classList.toggle('is-expanded');
    }
  });

  /* 価格の自由入力に数字以外が入らないようにする */
  document.addEventListener('input', function (event) {
    var el = event.target;
    if (!el || !el.classList || !el.classList.contains('bo-price-input')) return;
    var cleaned = el.value.replace(/[^\d]/g, '');
    if (cleaned !== el.value) el.value = cleaned;
  });
})();
